import phone from "phone";

const phoneValidation = (value: any, countryCode?: any) => {
  if (!value) return true;

  if (countryCode) {
    const formattedValue = `${countryCode}${value}`;
    const result = phone(formattedValue);
    return result.isValid;
  }

  const result = phone(value);

  return result.isValid;
};

export default phoneValidation;
